module.exports = __webpack_public_path__ + "static/media/Logo.149f6003.png";